var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 17V15H5V17H3ZM3 9V7H5V9H3ZM7 21V19H9V21H7ZM7 5V3H9V5H7ZM15 21V19H17V21H15ZM15 5V3H17V5H15ZM19 17V15H21V17H19ZM19 9V7H21V9H19ZM7 17V7H17V17H7ZM9 15H15V9H9V15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessIcon);
export default __webpack_public_path__ + "static/media/access-icon.188083364f85dde33d5c3e5c329095d4.svg";
export { ForwardRef as ReactComponent };